<div class="page-bg font-sans pb-10">
  <div class="max-w-[1400px] mx-auto px-5 sm:px-7 lg:px-10 pt-5">

    <!-- Header -->
<div class="section-header mb-5">

  <div class="widowed-header-left">

    <!-- Back Arrow -->
    <button
      type="button"
      class="widowed-back-btn"
      (click)="goBack()"
      aria-label="Go back">
      <span class="material-symbols-outlined">arrow_back</span>
    </button>

    <div>
      <h3>Widowed Profiles</h3>
      <p>
        Total Widowed Profiles:
        <strong class="text-gray-700">
          {{ widowedProfiles.length }} Profiles
        </strong>
      </p>
    </div>

  </div>

</div>

    <!-- Cards -->
    <div class="profile-grid">
      <div *ngFor="let profile of widowedProfiles"
           class="pcard"
           [routerLink]="['/profile-details', profile._id]">

        <!-- IMAGE -->
        <div class="pcard-img">
          <ng-container *ngIf="base64Images[profile._id]; else defaultAvatar">
            <img [src]="'data:image/jpeg;base64,' + base64Images[profile._id]" />
          </ng-container>

          <ng-template #defaultAvatar>
            <div class="pcard-avatar-placeholder">
              <span class="material-symbols-outlined text-[72px]" style="color:rgba(176,30,62,0.15)">
                person
              </span>
            </div>
          </ng-template>

          <div class="pcard-gradient"></div>

          <!-- Match Badge -->
          <div *ngIf="profile.match_badge" class="pcard-match-badge">
            <span class="material-symbols-outlined text-[11px]">
              {{
                profile.match_badge === 'Preference Match' ? 'verified_user' :
                profile.match_badge === 'Strong Match' ? 'thumb_up' :
                profile.match_badge === 'Partial Match' ? 'check_circle' :
                profile.match_badge === 'Similar Match' ? 'auto_awesome' :
                'explore'
              }}
            </span>
            {{profile.match_badge}}
          </div>

          <!-- Special Category Badge (Group B candidates) -->
          <div *ngIf="profile.special_category_badge" class="pcard-special-badge">
            <span class="material-symbols-outlined text-[11px]">volunteer_activism</span>
            {{profile.special_category_badge}}
          </div>

          <!-- Favorite Button -->
          <button (click)="$event.stopPropagation(); toggleFavorite(profile)"
                  class="pcard-fav-btn test-heart"
                  [class.is-favorited]="isFavorited(profile._id)">
            <span class="material-symbols-outlined text-[15px]">favorite</span>
          </button>

          <!-- Name & Age -->
          <div class="pcard-overlay">
            <div class="flex items-center gap-1.5 mb-0.5">
              <h3 class="font-display text-[15px] font-bold m-0 truncate text-white">
                {{profile.basic_info?.first_name}} {{profile.basic_info?.last_name}}
              </h3>
              <span class="material-symbols-outlined fill-icon text-[14px] text-white">verified</span>
            </div>

            <div class="flex items-center gap-1.5 text-white/85 text-[11px]">
              <span>{{getAge(profile.basic_info?.date_of_birth)}} yrs</span>
              <span class="opacity-40">·</span>
              <span>{{profile.personal_info?.marital_status || 'Widowed'}}</span>
            </div>

            <div *ngIf="profile.preference_fit !== undefined"
                 class="flex items-center gap-1 mt-1 text-[11px] font-semibold text-white">
              <span class="material-symbols-outlined text-[12px] fill-icon">favorite</span>
              {{ getCompatibility(profile) }}% Compatible
            </div>
          </div>
        </div>

        <!-- INFO -->
        <div class="info-chips">
          <span class="info-chip" title="Religion">
            <span class="material-symbols-outlined text-[12px]">temple_hindu</span>
            {{ getReligionName(profile.religion_info?.religion_id) }}
          </span>

          <span class="info-chip" title="Location">
            <span class="material-symbols-outlined text-[12px]">location_on</span>
            {{ getCityName(profile.residing_location?.city_id) }}
          </span>

          <span class="info-chip" title="Food">
            <span class="material-symbols-outlined text-[12px]">restaurant</span>
            {{profile.personal_info?.food || '--'}}
          </span>
        </div>

        <!-- ACTIONS -->
        <div class="pcard-actions">
          <a [routerLink]="['/profile-details', profile._id]"
             (click)="$event.stopPropagation()"
             class="btn-view">View</a>

          <ng-container [ngSwitch]="getSentInterestStatus(profile)">
            <button *ngSwitchCase="'Pending'"
                    (click)="$event.stopPropagation()"
                    class="btn-pending">
              <span class="material-symbols-outlined text-[14px]">schedule</span> Awaiting
            </button>

            <a *ngSwitchCase="'Accepted'"
               [routerLink]="['/chat']"
               (click)="$event.stopPropagation()"
               class="btn-chat">
              <span class="material-symbols-outlined text-[14px]">chat</span> Chat
            </a>

            <button *ngSwitchCase="'Denied'"
                    (click)="$event.stopPropagation()"
                    class="btn-declined">
              <span class="material-symbols-outlined text-[14px]">block</span> Declined
            </button>

            <button *ngSwitchDefault
                    (click)="$event.stopPropagation(); triggerInterestAlert(profile)"
                    class="btn-connect btn-ripple">
              <span class="material-symbols-outlined text-[15px] fill-icon">send</span> Connect
            </button>
          </ng-container>
        </div>

      </div>
    </div>

  </div>
</div>
